import React, { useMemo, useState } from "react";
import AppLayout from "../components/AppLayout";
import CourseCard from "../components/CourseCard";
import { courses, categories } from "../data/mockData";
import { ChevronDown } from "lucide-react";

export default function Catalog() {
    const [active, setActive] = useState("All");
    const [level, setLevel] = useState("All");
    const [sort, setSort] = useState("Newest");

    const filtered = useMemo(() => {
        let list = courses.slice();
        if (active !== "All") list = list.filter((c) => c.category === active);
        if (level !== "All") list = list.filter((c) => c.level === level);
        if (sort === "Price: Low to High") list.sort((a, b) => a.price - b.price);
        if (sort === "Price: High to Low") list.sort((a, b) => b.price - a.price);
        if (sort === "Top rated") list.sort((a, b) => b.rating - a.rating);
        return list;
    }, [active, level, sort]);

    return (
        <AppLayout searchPlaceholder="Search for courses...">
            <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
                <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">Courses</h1>
                <button data-testid="publish-course-btn" className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-lime text-ink-900 text-sm font-bold hover:bg-lime-hover transition-all hover:-translate-y-0.5">
                    + Publish course
                </button>
            </div>

            <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
                <div className="flex flex-wrap gap-2">
                    {categories.map((cat) => (
                        <button
                            key={cat}
                            onClick={() => setActive(cat)}
                            data-testid={`cat-${cat.toLowerCase().replace(/\s/g, "-")}`}
                            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all ${
                                active === cat ? "bg-white text-ink-900" : "text-gray-400 hover:text-white"
                            }`}
                        >
                            {cat}
                        </button>
                    ))}
                </div>
                <div className="flex gap-3">
                    <div className="relative">
                        <select
                            value={level}
                            onChange={(e) => setLevel(e.target.value)}
                            data-testid="filter-level"
                            className="appearance-none bg-ink-700 border border-white/10 rounded-full pl-5 pr-10 py-2.5 text-sm font-medium hover:border-white/20 focus:outline-none focus:border-lime/40 cursor-pointer"
                        >
                            <option>All</option>
                            <option>Beginner</option>
                            <option>Intermediate</option>
                            <option>Advanced</option>
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                    </div>
                    <div className="relative">
                        <select
                            value={sort}
                            onChange={(e) => setSort(e.target.value)}
                            data-testid="filter-sort"
                            className="appearance-none bg-ink-700 border border-white/10 rounded-full pl-5 pr-10 py-2.5 text-sm font-medium hover:border-white/20 focus:outline-none focus:border-lime/40 cursor-pointer"
                        >
                            <option>Newest</option>
                            <option>Top rated</option>
                            <option>Price: Low to High</option>
                            <option>Price: High to Low</option>
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {filtered.map((c) => <CourseCard key={c.id} course={c} />)}
            </div>

            {filtered.length === 0 && (
                <div className="text-center py-20 text-gray-500">No courses match your filters.</div>
            )}
        </AppLayout>
    );
}
